import { createApp } from 'vue'
import App from './App.vue'
// Bootstrap CSS and bundle for styling
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

createApp(App).mount('#app')
